<template>
  <div>
    <!-- LOADING -->
    <div v-if="!execution" class="text-center p-5">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <p class="mt-2">Carregando execução...</p>
    </div>

    <!-- CONTEÚDO -->
    <div v-else class="content-wrapper">
      <!-- HEADER -->
      <div class="page-header">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/checklist-executions">Execuções</router-link>
          </li>
          <li class="breadcrumb-item active">Visualizar</li>
        </ol>

        <h2 class="page-title">
          {{ nomeChecklist }}
        </h2>

        <p class="text-muted mt-1">
          Executado por
          <strong>{{ nomeUsuario }}</strong>
          em {{ formatDate(execution.data_execucao) }}
        </p>
      </div>

      <!-- CONTAINER CENTRAL -->
      <div class="checklist-container">
        <!-- GRUPOS -->
        <div
          v-for="grupo in grupos_checklist"
          :key="grupo.grupo_checklist_id"
          class="group-dark-container"
        >
          <div class="group-card">
            <!-- HEADER DO GRUPO -->
            <div class="group-header-lined">
              <div class="group-title-lined">
                <i class="ft-folder mr-2"></i>
                {{ grupo.titulo }}
              </div>

              <div class="group-title-line"></div>

              <span class="group-count">
                {{ grupo.item_checklist.length }} itens
              </span>
            </div>

            <!-- ITENS -->
            <div
              v-for="(item, index) in grupo.item_checklist"
              :key="item.item_checklist_id"
              class="item-container"
            >
              <div class="item-card">
                <div class="item-header">
                  <span class="item-index">{{ index + 1 }}</span>
                  <span class="item-titulo">{{ item.titulo }}</span>
                </div>

                <!-- RESPOSTAS -->
                <div class="item-resposta">
                  <!-- ALTERNATIVA -->
                  <div
                    v-if="item.tipo_pergunta == 1"
                    class="resposta-container"
                  >
                    <span class="resposta-label">Resposta:</span>
                    <template v-if="item.multipla_escolha">
                      <template v-if="getRespostasAlternativas(item.item_checklist_id).length">
                        <span
                          v-for="titulo in getRespostasAlternativas(item.item_checklist_id)"
                          :key="titulo"
                          class="resposta-badge mr-1"
                        >
                          {{ titulo }}
                        </span>
                      </template>
                      <span v-else class="resposta-badge">Não respondido</span>
                    </template>
                    <span v-else class="resposta-badge">
                      {{
                        getRespostaAlternativa(item.item_checklist_id) ||
                        "Não respondido"
                      }}
                    </span>
                  </div>

                  <!-- TEXTO -->
                  <div
                    v-else-if="item.tipo_pergunta == 2"
                    class="resposta-container"
                  >
                    <span class="resposta-label">Resposta:</span>
                    <div class="resposta-texto">
                      {{
                        getRespostaTexto(item.item_checklist_id) ||
                        "Não respondido"
                      }}
                    </div>
                  </div>

                  <!-- NÚMERO -->
                  <div
                    v-else-if="item.tipo_pergunta == 3"
                    class="resposta-container"
                  >
                    <span class="resposta-label">Resposta:</span>
                    <div class="resposta-numero">
                      {{
                        formatarNumero(
                          getRespostaNumero(item.item_checklist_id),
                        ) !== null &&
                        formatarNumero(
                          getRespostaNumero(item.item_checklist_id),
                        ) !== undefined
                          ? formatarNumero(
                              getRespostaNumero(item.item_checklist_id),
                            )
                          : "Não respondido"
                      }}
                      <i
                        v-if="isRespostaZero(item.item_checklist_id)"
                        class="fas fa-exclamation-triangle text-warning ml-1"
                        title="Atenção: valor preenchido como zero"
                      ></i>
                    </div>
                  </div>

                  <!-- IMAGEM -->
                  <div
                    v-if="getRespostaImagem(item.item_checklist_id)"
                    class="resposta-container"
                  >
                    <span class="resposta-label">Imagem:</span>
                    <div class="image-upload-wrapper">
                      <img
                        :src="getRespostaImagem(item.item_checklist_id)"
                        class="photo mt-2"
                        @click="
                          abrirImagemModal(
                            getRespostaImagem(item.item_checklist_id),
                            item.titulo,
                          )
                        "
                      />
                      <p class="image-hint">Clique para ampliar</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- OBSERVAÇÃO -->
        <div v-if="execution.observacao" class="obs-wrapper">
          <div class="obs-card">
            <h4>Observações</h4>
            <p>{{ execution.observacao }}</p>
          </div>
        </div>

        <!-- AÇÃO -->
        <div class="action-footer">
          <router-link
            to="/checklist-executions"
            class="btn btn-primary btn-lg"
          >
            <i class="fa fa-arrow-left mr-1"></i>
            Voltar
          </router-link>
        </div>
      </div>
    </div>

    <!-- MODAL IMAGEM -->
    <div
      v-if="imagemModal.show"
      class="modal-overlay"
      @click="fecharImagemModal"
    >
      <div class="modal-imagem-simples" @click.stop>
        <img
          :src="imagemModal.url"
          class="modal-imagem-full"
          @click="fecharImagemModal"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      execution: null,
      grupos_checklist: [],
      respostas_selecionadas: [],
      imagemModal: {
        show: false,
        url: "",
        titulo: "",
      },
    };
  },

  computed: {
    nomeChecklist() {
      return this.execution && this.execution.checklist_template
        ? this.execution.checklist_template.nome
        : "";
    },
    nomeUsuario() {
      return this.execution && this.execution.usuario
        ? this.execution.usuario.usuario_nome
        : "N/A";
    },
  },

  methods: {
    async getExecution(id) {
      const api =
        this.$store.state.api +
        `checklistexecutions/${id}?with[]=checklist_template&with[]=usuario&with[]=respostas_selecionadas&with[]=respostas_selecionadas.item&with[]=respostas_selecionadas.item.grupo_checklist&with[]=respostas_selecionadas.resposta`;

      const response = await this.$http.get(api);
      const data = response.data.data;
      const execution = Array.isArray(data) ? data[0] : data;

      this.execution = execution;
      this.respostas_selecionadas = execution.respostas_selecionadas || [];
      this.processResponses(this.respostas_selecionadas);
    },

    processResponses(responses) {
      const grupos = {};

      responses.forEach((r) => {
        if (!r.item || !r.item.grupo_checklist) return;

        const g = r.item.grupo_checklist;

        if (!grupos[g.grupo_checklist_id]) {
          grupos[g.grupo_checklist_id] = {
            grupo_checklist_id: g.grupo_checklist_id,
            titulo: g.titulo,
            item_checklist: [],
          };
        }

        // Deduplicar: não adicionar o mesmo item duas vezes (múltipla escolha gera várias linhas de resposta)
        const jaExiste = grupos[g.grupo_checklist_id].item_checklist.some(
          (i) => i.item_checklist_id === r.item.item_checklist_id,
        );
        if (!jaExiste) {
          grupos[g.grupo_checklist_id].item_checklist.push({
            item_checklist_id: r.item.item_checklist_id,
            titulo: r.item.titulo,
            tipo_pergunta: r.item.tipo_pergunta,
            multipla_escolha: r.item.multipla_escolha || false,
          });
        }
      });

      this.grupos_checklist = Object.values(grupos);
    },

    getRespostaAlternativa(id) {
      const r = this.respostas_selecionadas.find(
        (x) => x.item_checklist_id == id,
      );
      return r && r.resposta ? r.resposta.titulo : null;
    },
    getRespostasAlternativas(id) {
      return this.respostas_selecionadas
        .filter((x) => x.item_checklist_id == id && x.resposta)
        .map((x) => x.resposta.titulo);
    },
    getRespostaTexto(id) {
      const r = this.respostas_selecionadas.find(
        (x) => x.item_checklist_id == id,
      );
      return r ? r.valor_texto : null;
    },
    getRespostaNumero(id) {
      const r = this.respostas_selecionadas.find(
        (x) => x.item_checklist_id == id,
      );
      return r ? r.valor_numero : null;
    },
    formatarNumero(valor) {
      if (valor === null || valor === undefined) return null;
      // Remove zeros desnecessários no final (24.00 -> 24, 24.50 -> 24.5)
      return parseFloat(valor);
    },
    isRespostaZero(id) {
      return this.formatarNumero(this.getRespostaNumero(id)) === 0;
    },
    getRespostaImagem(id) {
      const r = this.respostas_selecionadas.find(
        (x) => x.item_checklist_id == id,
      );
      return r ? r.imagem_url : null;
    },

    getImageUrl(path) {
      if (!path) return null;
      if (path.indexOf("http") === 0) return path;
      return this.$store.state.api.replace("/api/v1/", "/") + "storage/" + path;
    },

    abrirImagemModal(url, titulo) {
      this.imagemModal.show = true;
      this.imagemModal.url = url;
      this.imagemModal.titulo = titulo;
    },

    fecharImagemModal() {
      this.imagemModal.show = false;
    },

    formatDate(date) {
      if (!date) return "N/A";
      return new Date(date).toLocaleString("pt-BR");
    },
  },

  mounted() {
    this.getExecution(this.$route.params.id);
  },
};
</script>

<style scoped>
.page-header {
  text-align: center;
  margin-bottom: 3rem;
}

.page-title {
  font-size: 2.4rem;
  font-weight: 700;
}

.checklist-container {
  max-width: 1100px;
  margin: 0 auto;
  padding-bottom: 3rem;
}

.group-card {
  border-radius: 16px;
  padding: 2.5rem;
  border: 1px solid var(--bs-border-color);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.505);
  margin-bottom: 3rem;
}

.group-header-lined {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2.5rem;
}

.group-title-lined {
  font-size: 1.6rem;
  font-weight: 600;
  color: rgb(0, 140, 255);
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.group-title-line {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(to right, rgb(0, 140, 255), transparent);
}

.group-count {
  font-size: 0.85rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: var(--bs-secondary-bg);
}

.item-block {
  margin-bottom: 2.2rem;
}

/* Container para cada item */
.item-container {
  margin-bottom: 1.5rem;
}

/* Card individual para cada pergunta/resposta */
.item-card {
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Light mode */
body[data-bs-theme="light"] .item-card,
.light-layout .item-card,
html[data-bs-theme="light"] .item-card,
:not([data-bs-theme="dark"]) .item-card {
  background-color: #ffffff;
  border-color: #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Dark mode */
body[data-bs-theme="dark"] .item-card,
.dark-layout .item-card {
  background-color: #2d3748;
  border-color: #4a5568;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Header do item com número e título */
.item-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

/* Light mode header */
body[data-bs-theme="light"] .item-header,
.light-layout .item-header,
html[data-bs-theme="light"] .item-header,
:not([data-bs-theme="dark"]) .item-header {
  border-bottom-color: #e9ecef;
}

/* Dark mode header */
body[data-bs-theme="dark"] .item-header,
.dark-layout .item-header {
  border-bottom-color: #4a5568;
}

.item-titulo {
  font-size: 1.3rem;
  font-weight: 600;
  margin-left: 0.75rem;
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

/* Light mode título */
body[data-bs-theme="light"] .item-titulo,
.light-layout .item-titulo,
html[data-bs-theme="light"] .item-titulo,
:not([data-bs-theme="dark"]) .item-titulo {
  color: #1a202c;
}

/* Dark mode título */
body[data-bs-theme="dark"] .item-titulo,
.dark-layout .item-titulo {
  color: #ffffff;
}

.item-index {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--bs-success);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-right: 0.75rem;
}

/* Light mode índice */
body[data-bs-theme="light"] .item-index,
.light-layout .item-index,
html[data-bs-theme="light"] .item-index,
:not([data-bs-theme="dark"]) .item-index {
  background: #28a745;
  color: #ffffff;
}

/* Dark mode índice */
body[data-bs-theme="dark"] .item-index,
.dark-layout .item-index {
  background: #48bb78;
  color: #1a202c;
}

/* Container para cada resposta */
.resposta-container {
  margin-top: 1rem;
}

.resposta-label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Light mode label */
body[data-bs-theme="light"] .resposta-label,
.light-layout .resposta-label,
html[data-bs-theme="light"] .resposta-label,
:not([data-bs-theme="dark"]) .resposta-label {
  color: #2d3748;
}

/* Dark mode label */
body[data-bs-theme="dark"] .resposta-label,
.dark-layout .resposta-label {
  color: #e2e8f0;
}

.resposta-badge {
  display: inline-block;
  max-width: 100%;
  font-size: 1.1rem;
  font-weight: 500;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-wrap: break-word;
  word-break: break-word;
}

.resposta-texto,
.resposta-numero {
  font-size: 1.1rem;
  font-weight: 500;
  padding: 0.8rem 1.2rem;
  border-radius: 8px;
  border-left: 4px solid #667eea;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow-wrap: break-word;
  word-break: break-word;
}

/* Light mode respostas texto/número */
body[data-bs-theme="light"] .resposta-texto,
body[data-bs-theme="light"] .resposta-numero,
.light-layout .resposta-texto,
.light-layout .resposta-numero,
html[data-bs-theme="light"] .resposta-texto,
html[data-bs-theme="light"] .resposta-numero,
:not([data-bs-theme="dark"]) .resposta-texto,
:not([data-bs-theme="dark"]) .resposta-numero {
  background-color: #f7fafc;
  color: #1a202c;
  border-left-color: #667eea;
}

/* Dark mode respostas texto/número */
body[data-bs-theme="dark"] .resposta-texto,
body[data-bs-theme="dark"] .resposta-numero,
.dark-layout .resposta-texto,
.dark-layout .resposta-numero {
  background-color: #4a5568;
  color: #ffffff;
  border-left-color: #90cdf4;
}

.image-hint {
  font-size: 0.85rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-style: italic;
}

/* Light mode image hint */
body[data-bs-theme="light"] .image-hint,
.light-layout .image-hint,
html[data-bs-theme="light"] .image-hint,
:not([data-bs-theme="dark"]) .image-hint {
  color: #718096;
}

/* Dark mode image hint */
body[data-bs-theme="dark"] .image-hint,
.dark-layout .image-hint {
  color: #a0aec0;
}

.photo {
  max-width: 240px;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}

.obs-card {
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
}

/* Action footer */
.action-footer {
  text-align: center;
  margin-top: 2rem;
}

/* Modal da imagem */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  padding: 20px;
}

.modal-imagem-simples {
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-imagem-full {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
}
</style>
